import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { install as dvHandleOffsetExtensionInstall } from './dvHandleOffset';
import { install as dvMoveHandleOffsetExtensionInstall } from './dvMoveHandleOffset';
import { install as borderRadiusExtensionInstall } from './borderRadius';

export function install(registers: EChartsExtensionInstallRegisters) {
  dvHandleOffsetExtensionInstall(registers);
  dvMoveHandleOffsetExtensionInstall(registers);
  borderRadiusExtensionInstall(registers);
}
